import { css } from 'linaria';

export const priceMainStickyStyle = css`
  height: inherit;
  font-weight: 500;
  font-size: var(--space-225);
  line-height: var(--space-300);
  margin-right: var(--space-200);
  color: var(--text-primary);
`;

export const oldNewPriceStickyContainer = css`
  display: flex;
  flex-direction: column;
`;

export const priceSpecialStickyStyle = css`
  height: inherit;
  font-weight: 500;
  font-size: var(--space-225);
  line-height: var(--space-300);
  color: var(--text-primary);
`;

export const priceOldNewStickyStyle = css`
  color: var(--secondary-red-primary);
  font-weight: 700;
`;

export const marginLeftSignaturePrimarySticky = css`
  margin-left: var(--space-50);
`;

export const marginLeftSignatureSecondarySticky = css`
  margin-left: var(--space-25);
`;

export const marginSlashPrimarySticky = css`
  margin: 0 var(--space-35);
`;

export const marginSlashSecondarySticky = css`
  margin: 0 var(--space-25);
`;

export const priceFractCurrencyStickyStyle = css`
  font-weight: 700;
  font-size: var(--space-150);
  line-height: var(--space-250) !important;
`;

export const addToBasketSticky = css`
  height: var(--space-500) !important;
`;

export const counterSticky = css`
  height: var(--space-500) !important;
  padding: 0 var(--space-125);
  width: 128px !important;
`;

export const bestPriceNameplateStickyContainer = css`
  display: flex;
  position: absolute;
  bottom: var(--space-775);
  left: var(--space-200);
`;

export const priceSecondaryStickyStyle = css`
  height: inherit;
  font-weight: 400;
  font-size: var(--space-150);
  line-height: var(--space-200);
  color: rgb(153, 153, 153);
`;

export const secondaryPriceHidden = css`
  display: none;
`;

export const specialNewCurrencyPadding = css`
  padding-left: var(--space-25);
`;

export const oldPriceStickyContainer = css`
  display: block;
  width: fit-content;
  line-height: var(--space-300) !important;

  &:after {
    bottom: var(--space-125);
  }
`;
